// Seat badge fallback selection — ClanWorkbench's collapsed-row honesty fix
// (2026-07-21). The seat-detail fetch (GET /clan/:name) is enabled-on-expand
// only, so a COLLAPSED clan card has no live ClanSeat[] to derive claimed/
// pending/ghost counts from. The old code defaulted `seats` to `[]` in that
// gap, which silently rendered a fabricated "0 claimed / 0 pending / 0
// ghost" — indistinguishable from a clan that genuinely has zero seats.
//
// This resolves, in priority order:
//   1. live     — the expanded detail fetch actually returned. Even an
//                 honest empty array is real data, never a placeholder.
//   2. snapshot — the list payload's own seatCounts (AdminClan.seatCounts,
//                 new field — absent on old payloads or when the server
//                 genuinely couldn't count).
//   3. unavailable — neither exists yet; the caller must render a muted
//                 placeholder, NEVER zeros.
//
// "Fresher data wins": once a row is expanded and its own fetch resolves,
// live always beats the list's snapshot, even if the snapshot is present.

export interface SeatCounts {
  claimed: number;
  pending: number;
  ghost: number;
}

export type SeatBadgeSource = 'live' | 'snapshot' | 'unavailable';

export interface SeatBadge {
  source: SeatBadgeSource;
  counts: SeatCounts | null;
}

export function resolveSeatBadge(params: {
  liveCounts: SeatCounts | undefined;
  snapshotCounts: SeatCounts | undefined;
}): SeatBadge {
  if (params.liveCounts) return { source: 'live', counts: params.liveCounts };
  if (params.snapshotCounts) return { source: 'snapshot', counts: params.snapshotCounts };
  return { source: 'unavailable', counts: null };
}
